var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-testid": "exterior-area-form" } },
    [
      _c("HouseForm", {
        attrs: { index: _vm.index, value: _vm.value },
        on: {
          input: (area) => _vm.$emit("input", area),
          delete: function ($event) {
            return _vm.$emit("delete", _vm.index)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }